import { browserFetch } from "./fetch";
import * as constant from "../constants";
function getRuntimeConfig(params) {
  const { locale = constant.DEFAULT_LOCALE, appId = constant.DEFAULT_APP_ID, theme = constant.DEFAULT_THEME, enableTea = constant.DEFAULT_ENABLE_TEA, apiDomain = constant.DEFAULT_API_DOMAIN } = params;
  return browserFetch({
    url: `${apiDomain}/api/v1/web-cookie-privacy/config`,
    params: {
      locale,
      appId,
      theme,
      tea: enableTea ? 1 : 0
    },
    withCredentials: true,
    headers: {
      ["x-web-privacy-sdk-ver"]: "1.0.1",
      ["x-pns-referrer"]: `${location.protocol}//${location.host}${location.pathname}`
    }
  });
}
export {
  getRuntimeConfig
};
